let marqueeRafId = null;
let marqueeSections = [];

document.addEventListener("DOMContentLoaded", function () {
	initMarquee();
});

// marquee au scroll
function initMarquee() {
	marqueeSections = [];

	document.querySelectorAll("[data-section-id]").forEach(section => {
		const marquee = section.querySelector(".mm-wrapper-scrub");
		if (marquee) {
			marqueeSections.push({ section, marquee, currentX: 0 });
		}
	});

	if (marqueeRafId || marqueeSections.length === 0) return;

	function update() {
		const vh = window.innerHeight;
		marqueeSections.forEach(item => {
			const rect = item.section.getBoundingClientRect();
			// start: section top at viewport bottom → progress 0
			// end: section bottom at viewport top → progress 1
			const progress = Math.max(0, Math.min(1, (vh - rect.top) / (vh + rect.height)));
			const targetX = -20 * progress;
			item.currentX += (targetX - item.currentX) * 0.05;
			item.marquee.style.transform = `translateX(${item.currentX}%)`;
		});
		marqueeRafId = requestAnimationFrame(update);
	}

	marqueeRafId = requestAnimationFrame(update);
}

// Réinitialiser l'animation lors du changement de section
document.addEventListener("shopify:section:load", function (event) {
	if (event.target.classList.contains("mm-edito-section")) {
		marqueeSections = [];
		document.querySelectorAll("[data-section-id]").forEach(section => {
			const marquee = section.querySelector(".mm-wrapper-scrub");
			if (marquee) {
				marqueeSections.push({ section, marquee, currentX: 0 });
			}
		});
	}
});
